import { GoToOrder } from 'components/static-pages/GoTo/GoToOrder';

const GoToOrderRendering = (): JSX.Element => {
	return <GoToOrder />;
};

export default GoToOrderRendering;
